<template>
<div>
    <div
        v-if="title != null"
        style="text-align: center; font-weight: 700; margin-top: 30px; margin-bottom: 15px; font-size: 20px;"
    >
        {{title}}
    </div>

   
    <v-data-table
        :headers="table_headers"
        :items="table_rows"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"

        :sort-by.sync="sort_by"
        :sort-desc.sync="sort_desc"
    >
    
        <template v-slot:item.percent="{ item }">
            {{item.percent}}%
        </template>

        <template v-slot:item.value="{ item }">
            {{  (currency ? '$' : '')+parseInt(item.value).toLocaleString()}}
        </template>
    
    </v-data-table>
       
</div>
</template>

<script>
const _ = require('lodash');

export default {

    props: {
        title: {
            type: String,
            default: function() { return "Set title to properly title the chart!"}
        },

        currency: {
            type: Boolean,
            default: function() { return false; }
        },

        table_headers: {
            type: Array,
            default: function() { return []; }
        },

        table_rows: {
            type: Array,
            default: function() { return []; }
        },
    },

    data() {
        return {
            'sort_by': 'value',
            'sort_desc': true,
        }
    },

    methods: {
    },
}
</script>

<style lang="scss" scoped>

</style>